import type { Progress } from "ky";
import type { UploadProgressHandler } from "ls/api/common/server";
import type { RefOrGetter } from "ls/common/types";
import { computed, readonly, ref, toValue } from "vue";

export function useUploadProgressStats(event: RefOrGetter<Progress | undefined>) {
  const current = computed(() => toValue(event)?.transferredBytes);
  const total = computed(() => toValue(event)?.totalBytes ?? undefined);

  const percentage = computed(() => {
    const percent = toValue(event)?.percent;
    if (typeof percent === "number") {
      return percent * 100;
    }
    return 0;
  });

  return {
    current: readonly(current),
    total: readonly(total),
    percentage,
  };
}

export function useUploadProgress() {
  const eventRef = ref<Progress>();

  const onUploadProgress: UploadProgressHandler = event => {
    eventRef.value = event;
  };

  function reset() {
    eventRef.value = undefined;
  }

  const { current, total, percentage } = useUploadProgressStats(eventRef);

  return {
    onUploadProgress,
    current,
    total,
    percentage,
    reset,
  };
}
